import { PageHeader } from 'antd';
import React from 'react'
import { connect } from 'react-redux';
import { openDrawer } from '../actions/Drawer';
import BusSignsList from '../components/BusSignsList';

class BusSigns extends React.Component {
    render() {
        document.title = 'Autobusové označníky | Smart4City';
        return (
            <div>
                <PageHeader
                    title="Autobusové označníky"
                    subTitle="seznam autobusových označníků"
                    extra={[]}
                >
                    <BusSignsList />
                </PageHeader>
            </div>
        )
    }
}
const mapStateToProps = state => ({
});

export default connect(
  mapStateToProps,
  { openDrawer }
)(BusSigns)                